import { urls } from 'constants/urls';
import { delay, http, HttpResponse } from 'msw';
import { mockedSearchedTrucker } from 'open-search/_mock_';

const searchTruckerProfile = [
  http.get(`${process.env.BFF_TRUCKER_PROFILE_URL}${urls.trucker.searchTrucker}`, async () => {
    await delay();
    return HttpResponse.json(mockedSearchedTrucker, { status: 200 });
  }),
];

export { searchTruckerProfile };
